import React from 'react';

type BookDetailLeftRailProps = {
  isCollapsed: boolean;
  children: React.ReactNode;
};

const BookDetailLeftRail: React.FC<BookDetailLeftRailProps> = ({
  isCollapsed,
  children,
}) => {
  return (
    <aside className={`book-detail-left-rail ${isCollapsed ? 'book-detail-left-rail--collapsed' : ''}`}>
      <section className="book-detail-rail-section book-detail-rail-section--chapters" aria-label="Chapter navigation">
        {children}
      </section>
    </aside>
  );
};

export default BookDetailLeftRail;
